import React, { useEffect, useRef } from "react";
import "./Setup.css";
import { useAuth } from "../../utils/AuthContext";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Setup() {
    const { setChesscom } = useAuth();
    const [autoSetupFailed, setAutoSetupFailed] = useState(false);
    const [usernameNotFound, setUsernameNotFound] = useState(false);
    const setupForm = useRef(null);
    const navigate = useNavigate();

    const handleConfirm = async (e) => {
        e.preventDefault();
        const chesscomUsername = setupForm.current.chesscom.value;
        if (!setChesscom) {
            return; // not signed in
        }
        if (chesscomUsername.length === 0) {
            return;
        }
        const response = await setChesscom(chesscomUsername);
        if (response) {
            console.log("[SUCCES] setting chess.com username ");
            navigate("/account");
        } else {
            console.log("[ERROR] setting chess.com username was not succesful");
            setUsernameNotFound(true);
        }
    };

    const handleOneClickSetup = () => {
        window.location.href = "https://www.chess.com/home";
    };

    useEffect(() => {
        const autoSetup = async () => {
            if (
                window.location.href === "https://www.chess.com/home?setup=true"
            ) {
                // Try to find the username from the DOM
                const usernameLink = document.querySelector(
                    'a.home-username-link[data-track-home-action-to-user-activity][data-name="Home Button Clicked"]'
                );
                if (usernameLink && usernameLink.href) {
                    // Extract username from the href, e.g., https://www.chess.com/member/lucasxparis
                    const match = usernameLink.href.match(/\/member\/([^/]+)/);
                    const chesscomUsername = match ? match[1] : null;
                    if (chesscomUsername) {
                        const response = await setChesscom(chesscomUsername);
                        if (response) {
                            console.log("[SUCCES] setting chess.com username ");
                            navigate("/account");
                        } else {
                            console.log(
                                "[ERROR] setting chess.com username was not succesful"
                            );
                            setUsernameNotFound(false);
                            setAutoSetupFailed(true);
                        }
                    }
                }
            }
        };
        autoSetup();
        sessionStorage.removeItem("verificationEmailSent");
        // eslint-disable-next-line
    }, []);

    return (
        <>
            <title>Setup Your Profile | Oakmate</title>
            <meta
                name="description"
                content="Complete your Oakmate profile setup to personalize your experience."
            />
            <div className="setupPage">
                <div className="setUp">
                    <div className="auth-component">
                        <div className="auth-header-wrapper">
                            <div className="auth-header">Quick Setup</div>
                            <div className="auth-subheader">
                                Set your chess platforms infos
                            </div>
                        </div>
                        <form
                            ref={setupForm}
                            onSubmit={handleConfirm}
                            className="auth-form"
                            autoComplete="off"
                        >
                            <div className="auth-form-main">
                                <label className="form-field glassy-field">
                                    <input
                                        type="text"
                                        placeholder=" "
                                        name="chesscom"
                                        className="form-input"
                                        autoComplete="off"
                                        autoCapitalize="off"
                                        autoCorrect="off"
                                        spellCheck={false}
                                        inputMode="text"
                                    />
                                    <span className="form-label">
                                        Chess.com's username
                                    </span>
                                </label>
                            </div>

                            <button
                                type="submit"
                                value="Register"
                                className="submit-btn"
                                onClick={handleConfirm}
                            >
                                Confirm
                            </button>
                            <div
                                className="forgot-password"
                                onClick={handleOneClickSetup}
                            >
                                What is my username?
                            </div>
                        </form>
                        {/* <div className="or-wrapper">
                            <div className="auth-separator" />
                            <div className="auth-or-text">OR</div>
                            <div className="auth-separator" />
                        </div>
                        <button className="signInGoogle">
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 28 28"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M10.0003 3.6H7.12031C5.32814 3.6 4.43139 3.6 3.74688 3.94878C3.14476 4.25557 2.65557 4.74476 2.34878 5.34688C2 6.03139 2 6.92814 2 8.72031V20.8803C2 22.6725 2 23.5681 2.34878 24.2526C2.65557 24.8547 3.14476 25.3448 3.74688 25.6516C4.43072 26 5.32639 26 7.11505 26H19.2849C21.0736 26 21.968 26 22.6518 25.6516C23.254 25.3448 23.7448 24.8543 24.0516 24.2521C24.4 23.5683 24.4 22.6736 24.4 20.8849V18M26 10V2M26 2H18M26 2L14.8 13.2"
                                    stroke="#DEDEDD"
                                    strokeWidth="2.4"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>

                            <div
                                className="signInGoogle-text"
                                onClick={handleOneClickSetup}
                            >
                                One Click Setup
                            </div>
                        </button> */}
                        {autoSetupFailed ? (
                            <div className="autoFailed">
                                One Click Setup Failed, <br /> please input
                                manually
                            </div>
                        ) : null}
                        {usernameNotFound ? (
                            <div className="autoFailed">
                                Username not found, <br /> please double check
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        </>
    );
}
